module.exports = __webpack_public_path__ + "static/media/math.c144f149.png";


//////////////////
// WEBPACK FOOTER
// ./src/math.png
// module id = 675
// module chunks = 0